import { Carousel } from "flowbite-react";
import { Link } from "react-router-dom";
export function Component() {
  return (
    <div className="w-full sm:h-[300px] md:h-[300px] h-[400px] mx-auto items-center">
      <Carousel>
        <div className="flex h-full justify-center bg-[#C8102E] text-white px-[15%] flex-col">
          <p className="md:text-xl sm:text-lg text-sm">
            <span className="font-bold py-4 md:text-2xl text-2xl">
              2026 Events Released!
            </span>
            <br />
            Check out the events page, for new events, competitions and event
            information
          </p>
          <div className="mt-6 self-start">
            <button className="px-4 py-2 bg-white text-[#C8102E] font-bold">
              <Link to="/calender">Calandar</Link>
            </button>
          </div>
        </div>
        <div className="flex h-full justify-center bg-[#012169] text-white px-[15%] flex-col">
          <p className="  md:text-xl sm:text-lg text-sm ">
            <span className="font-bold py-4 md:text-2xl text-2xl">
              Meet the Team
            </span>
            <br />
            Meet the team behind Rising Sun Judo Club, including the club
            managers and instructors. If you want to find out more send a
            message via the Contact Page
          </p>
          <div className="mt-6 self-start">
            <button className="px-4 py-2 bg-[#ffffff] text-[#012169] font-bold">
              <Link to="/team">Find Out More</Link>
            </button>
          </div>
        </div>
        <div className="flex h-full justify-center bg-[#08193f] text-white px-[15%] flex-col">
          <p className="  md:text-xl sm:text-lg text-sm ">
            <span className="font-bold py-4 md:text-2xl text-2xl">
              View Our Latest Pictures
            </span>
            <br></br>Check out the latest pictures taken from recent events with
            our various teams.
          </p>
          <div className="mt-6 self-start">
            <button className="px-4 py-2 bg-white text-[#08193f] font-bold">
              <Link to="/gallery">Find Out More</Link>
            </button>
          </div>
        </div>
      </Carousel>
    </div>
  );
}

export default Component;
